export default __webpack_public_path__ + "static/media/redux.1b4bb5fc.png";